import React, { useEffect, useState } from 'react';
import Header from './components/header/header.jsx';
import TopNav from './components/top-nav/top-nav.jsx';
import Sidebar from './components/sidebar/sidebar.jsx';
import Content from './components/content/content.jsx';
import Footer from './components/footer/footer.jsx';
import ThemePanel from './components/theme-panel/theme-panel.jsx';
import { AppSettings } from './config/app-settings.js';
import styled, { keyframes } from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { openAlert, openMessage } from './redux/slice/messageSlice.js';
import { Link, Navigate } from 'react-router-dom';
import mqtt from "mqtt/dist/mqtt";
import './index.css';
import Collapse from 'react-bootstrap/Collapse';
import { getRoleModuleSidebar } from './redux/action/roleModuleAction.js';
import { getImageAlert } from './redux/action/minioAction.js';
import Cookies from 'js-cookie';
import { MQTT_CONNECT, MQTT_HOST, MQTT_PASS, MQTT_PORT, MQTT_PROTOCOL, MQTT_USER } from './constants.js';
// import { Collapse } from 'react-bootstrap';

const CollapseContainer = styled.div`
  overflow: hidden;
  transition: max-height 0.3s ease, transform 0.3s ease; /* Tambahkan animasi untuk max-height dan transform */
  max-height: ${(props) => (props.isOpen ? '1000px' : '0')}; /* Atur nilai maksimum tinggi untuk animasi collapse */
  transform: translateY(${(props) => (props.isOpen ? '0' : '-100%')}); /* Geser elemen ke atas saat ditutup */
`;

const CollapseContent = styled.div`
  padding: 10px;
  background-color: #f1f1f1;
`;

const Toast = styled.div`
  visibility: hidden;
  position: absolute;
  right: 10px;
  top: 15px;
  z-index: 1100;
  background: ${(props) => props.color};
  padding: 15px;
  border-radius: 7px;
  border-left: 7px solid white;
  width: 250px;
  transition: visibility 0s, opacity 0.5s linear;
  &.active {
    visibility: visible;
  }
`
const ToastBody = styled.div`
  color: white;
`
function App() {
	const dispatch = useDispatch()
	const { message, type, isOpenMessage, alertData, imageData } = useSelector((state) => state.message)
	// console.log(alertData)
	const [imageDwi, setImageDwi] = useState('')
	var defaultOptions = {
		appMode: '',
		appTheme: '',
		appCover: '',
		appHeaderNone: false,
		appSidebarNone: false,
		appSidebarCollapsed: false,
		appContentNone: false,
		appContentClass: '',
		appContentFullHeight: false,
		appBoxedLayout: false,
		appFooter: false,
		appTopNav: false
	};
	const [appHeaderNone, setAppHeaderNone] = useState(defaultOptions.appHeaderNone);
	const [appSidebarNone, setAppSidebarNone] = useState(defaultOptions.appSidebarNone);
	const [appSidebarCollapsed, setAppSidebarCollapsed] = useState(defaultOptions.appSidebarCollapsed);
	const [appContentNone, setAppContentNone] = useState(defaultOptions.appContentNone);
	const [appContentClass, setAppContentClass] = useState(defaultOptions.appContentClass);
	const [appContentFullHeight, setAppContentFullHeight] = useState(defaultOptions.appContentFullHeight);
	const [appBoxedLayout, setAppBoxedLayout] = useState(defaultOptions.appBoxedLayout);
	const [appFooter, setAppFooter] = useState(defaultOptions.appFooter);
	const [appTopNav, setAppTopNav] = useState(defaultOptions.appTopNav);
	const providerValue = {
		setAppHeaderNone, 
		setAppSidebarNone, 
		setAppSidebarCollapsed, 
		setAppContentNone, 
		setAppContentClass,
		setAppContentFullHeight,
		setAppBoxedLayout,
		setAppFooter,
		setAppTopNav
	};
		
	var handleSetAppTheme = (value) => {
		if (value) {
			var newTheme = value;
			for (var x = 0; x < document.body.classList.length; x++) {
				if ((document.body.classList[x]).indexOf('theme-') > -1 && document.body.classList[x] !== newTheme) {
					document.body.classList.remove(document.body.classList[x]);
				}
			}
			
			if (localStorage && value) {
				localStorage.appTheme = value;
			}
			
			document.body.classList.add(newTheme);
			document.dispatchEvent(new Event('theme-reload'));
		}
	}
	
	var handleSetAppMode = (value) => {
		if (value) {
			document.documentElement.setAttribute('data-bs-theme', value);
		}
	}
		
	var handleSetAppCover = (value) => {
		if (value) {
			var htmlElm = document.querySelector('html');
			for (var x = 0; x < document.documentElement.classList.length; x++) {
				var targetClass = document.documentElement.classList[x];
				if (targetClass.search('bg-cover-') > -1) {
					htmlElm.classList.remove(targetClass);
				}
			}
			htmlElm.classList.add(value);
		
			if (localStorage && value) {
				localStorage.appCover = value;
			}
		}
	}
	
	useEffect(() => {
		if (defaultOptions.appMode) {
			handleSetAppMode(defaultOptions.appMode);
		}
		if (defaultOptions.appTheme) {
			handleSetAppTheme(defaultOptions.appTheme);
		}
		if (defaultOptions.appCover) {
			handleSetAppCover(defaultOptions.appCover);
		}
    
		if (localStorage) {
			if (typeof localStorage.appMode !== 'undefined') {
				handleSetAppMode(localStorage.appMode);
			}
			if (typeof localStorage.appTheme !== 'undefined') {
				handleSetAppTheme(localStorage.appTheme);
			}
			if (typeof localStorage.appCover !== 'undefined') {
				handleSetAppCover(localStorage.appCover);
			}
		}
		
		// eslint-disable-next-line
  }, []);
  const colorToast = type === 'success' ? 'rgba(89, 214, 103, 0.9)' : 'rgba(229, 33, 33, 0.9)'
  useEffect(() => {
    if (isOpenMessage) {
      setTimeout(function () {
        dispatch(openMessage({ message: '', type: '', open: false }))
      }, 5000)
    }
  }, [isOpenMessage])
  const [alertVisible, setAlertVisible] = useState(false);

  const closeAlert = () => {
    setAlertVisible(false);
	dispatch(openAlert({data: ''}))
  };
  const convertTime = (type, data) => {
	let split = data.split(' ')
	if(type === 'date'){
		return split[0]
	}else{
		let timesee = split[1].split('.')[0]
		return timesee
	}
  }
  const [isOpen, setIsOpen] = useState(false);

  const toggleCollapse = () => {
	const userImage = JSON.parse(localStorage.getItem("user"))
	dispatch(getImageAlert({token: userImage.access_token, fileName: alertData[0].fileName }))
    setIsOpen(!isOpen);
  };

  const token = Cookies.get('accessToken');
  useEffect(()=>{
	if(token){
		const user = JSON.parse(localStorage.getItem("user"))
		// console.log(user)
		dispatch(getRoleModuleSidebar({token: user.access_token, id: user.roleId}))
		//mqtt gen
		const client = mqtt.connect(`${MQTT_CONNECT}`,{
			host: MQTT_HOST, // Ganti dengan alamat broker MQTT Anda
			port: MQTT_PORT, // Port standar untuk koneksi TCP MQTT
			protocol: MQTT_PROTOCOL, // Menentukan protokol koneksi (mqtt/tcp/ws)
			username: MQTT_USER, // Ganti dengan username MQTT Anda
			password: MQTT_PASS, // Ganti dengan password MQTT Anda
		});
		client.on('connect', () => {
		console.log('Terhubung ke broker MQTT');
		client.subscribe('jpo/alert'); // Ganti 'jpo/alert' dengan topik MQTT yang ingin Anda dengarkan
		});

		client.on('message', (topic, message) => {
			// console.log(message.toString())base64
			console.log('CONNECTED')
			dispatch(openAlert({data: message.toString()}))
		// Lakukan sesuatu dengan pesan MQTT yang diterima di sini
		});
		return () => {
			client.end(); // Menutup koneksi saat komponen di-unmount
		};
	}
  },[])
  useEffect(()=>{
	if(alertData.length > 0){
		setAlertVisible(true)
	}
  },[alertData])
  useEffect(()=>{
	if(imageData !== ''){
		const reader = new FileReader();
		reader.onload = () => {
			const base64data = reader.result.split(',')[1];
			setImageDwi(base64data)
		};
		reader.onerror = () => {                
			console.error('Error reading image data');
		};
		reader.readAsDataURL(imageData);
	}
  },[imageData])
  
  const closeAlertNotif = () => {
	closeAlert()
  }
  
  if (!token) {
    return <Navigate exact to="/login" />
  }
	
	return (
		<AppSettings.Provider value={providerValue}>

			{alertVisible && (
				<div className="alert-backdrop">
					<div className={`alert-new`}>
						<div className="row">
							<div className="col-4" style={{textAlign: 'center'}}>
								<img src="https://i.pinimg.com/originals/fb/11/55/fb1155591460c455edf3ced130b127b9.gif" alt="" style={{width: 150}} />
								<span style={{fontWeight: 'bold', fontSize: 20}}>PERHATIAN!</span>
							</div>
							<div className="col-8">
								<div className="row">
									<div className="col-12">
										<span style={{fontWeight: 'bold', fontSize: 28}}>{alertData[0].alertName}</span>
									</div>
									<div className="col-12 mb-1">
										<span style={{fontSize: 20}}>{alertData[0].alertText}</span>
									</div>
									<div className="col-12">
										<table style={{width: '100%'}}>
											<tr>
												<td style={{width: '30%'}}>
													Lokasi
												</td>
												<td>
													:
												</td>
												<td>
													{alertData[0].siteName}
												</td>
											</tr>
											<tr>
												<td style={{width: '20%'}}>
													Titik Kamera
												</td>
												<td>
													:
												</td>
												<td>
													{alertData[0].sensorName}
												</td>
											</tr>
											<tr>
												<td>
													Tanggal
												</td>
												<td>
													:
												</td>
												<td>
													{convertTime('date', alertData[0].eventTime)}
												</td>
											</tr>
											<tr>
												<td>
													Jam
												</td>
												<td>
													:
												</td>
												<td>
													{convertTime('time', alertData[0].eventTime)}
												</td>
											</tr>
										</table>
									</div>	
								</div>
							</div>
						</div>

						<hr></hr>
						<CollapseContainer isOpen={isOpen}>
							<CollapseContent>
								<img src={'data:image/jpg;base64,' + imageDwi} style={{width: '100%'}} alt="cover" />
							</CollapseContent>

							<hr></hr>
						</CollapseContainer>
						<div className="alert-footer">
							<button className='btn btn-primary' onClick={toggleCollapse} style={{marginRight: 5}}>{`${isOpen ? 'Tutup' : 'Lihat'} Gambar`}</button>
							<a href={alertData[0].analyticId === 'PPLLEN' ? '/deteksi-langsung/pendeteksi-orang-bersandar' : '/deteksi-langsung/pendeteksi-orang-berpotensi-melompat'}>
								<button className='btn btn-primary' onClick={()=>closeAlertNotif()} style={{marginRight: 5}}> Pergi ke Site</button>
							</a>
							{/* <Link to={'/deteksi-langsung/pendeteksi-melompat'}>
								<button className='btn btn-primary' onClick={()=>closeAlertNotif()} style={{marginRight: 5}}> Pergi ke Site</button>
							</Link> */}
							<button className='btn btn-danger' onClick={()=>closeAlert()}>Tutup</button>
						</div>
					</div>
				</div>
			)}
			<div className={
				'app ' +
				(appBoxedLayout ? 'app-boxed-layout ' : '') + 
				(appContentFullHeight ? 'app-content-full-height ' : '') + 
				(appHeaderNone ? 'app-without-header ' : '') + 
				(appSidebarNone ? 'app-without-sidebar ' : '') + 
				(appSidebarCollapsed ? 'app-sidebar-collapsed ' : '') + 
				(appFooter ? 'app-footer-fixed ' : '') + 
				(appTopNav ? 'app-with-top-nav ' : '')
			}>
				<Toast className={isOpenMessage ? 'active' : ''} color={colorToast}>
					<ToastBody id="toast-notif">
					<div className='row'>
						<div className="col-xs-3 col-md-3 col-sm-3 col-lg-3"
						style={{ textAlign: 'center', alignSelf: 'center' }}
						>
						<i className='fas fa-check'></i>
						</div>
						<div className="col-xs-9 col-md-9 col-sm-9 col-lg-9">
						<div className='row'>
							<div className="col-xs-12 col-md-12 col-sm-12 col-lg-12">
							<span style={{ fontWeight: 600, fontSize: 14 }}>{type.toUpperCase()}</span>
							</div>
							<div className="col-xs-12 col-md-12 col-sm-12 col-lg-12">
							<span style={{ fontWeight: 400, fontSize: 12 }}>{message}</span>
							</div>
						</div>
						</div>
					</div>
					</ToastBody>
				</Toast>
				{!appHeaderNone && (<Header />)}
				{appTopNav && (<TopNav />)}
				{!appSidebarNone && (<Sidebar />)}
				{!appContentNone && (<Content className={appContentClass} />)}
				{appFooter && (<Footer />)}
				<ThemePanel />
			</div>
		</AppSettings.Provider>
	)
}

export default App;